/* eslint-disable react/no-unescaped-entities */
import { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import EllipsisText from 'react-ellipsis-text'

import Layout from '../components/Layout'
import SideWidget from '../components/SideWidget'
import { withTranslation, i18n, Link } from '../i18n'

import { Container, LocationDiv, StarWidgetContainer } from '../styles/singleArtistStyles'
import Footer from '../components/Footer'
import DescriptionSection from '../components/DescriptionSection'
import EmbedContent from '../components/EmbedContent'
import { fetchSingleArtist } from '../api/artists'

import { normalizeDurationTime } from '../api/utils'
import { StarWidget } from '../components/StarWidget'
import { favoriteRoute } from '../api/routes'
import { Star } from '../public/static/svgs/Star'

@inject('store')
@observer
class Artists extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    store: PropTypes.instanceOf(Object).isRequired
  }

  state = {
    windowWidth: 1440
  }

  static async getInitialProps({ req, query, mobxStore }) {
    const currentLanguage = req ? req.language : i18n.language
    const { token } = mobxStore.user
    const artist = query.artist || (await fetchSingleArtist(query, currentLanguage, token))
    if (artist.artistsProgram === undefined) artist.artistsProgram = artist.performances
    mobxStore.setArtist(artist)
    return {
      namespacesRequired: ['common', 'artists', 'contacts', 'auth', 'reset-password']
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions)
    this.checkWindowWidth()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  updateDimensions = () => {
    this.checkWindowWidth()
    this.setState({ windowWidth: window.innerWidth })
  }

  checkWindowWidth = () => {
    this.setState({ windowWidth: window.innerWidth })
  }

  onStarPress = (id, token, favorited, updateArtist, toggleLoginModal) => {
    if (!token) {
      toggleLoginModal(true, this.props.t('common:make_an_account'))
    } else {
      favoriteRoute(id, 'artists', undefined, token, favorited).then(() => {
        updateArtist(id)
      })
    }
  }

  onSmallStarPress = (artistId, id, token, favorited, updatePerformance, updateArtist, toggleLoginModal) => {
    if (!token) {
      toggleLoginModal(true, this.props.t('common:make_an_account'))
    } else {
      favoriteRoute(id, 'performances', undefined, token, favorited).then(() => {
        updateArtist(artistId)
      })
    }
  }

  render() {
    const {
      t,
      store: {
        user: { token },
        toggleLoginModal,
        updatePerformance,
        updateArtist,
        artist: {
          id,
          description,
          long_description,
          name,
          vk_playlist_code,
          links,
          youtube_links,
          tags,
          header_image,
          photo,
          performances,
          favorited_count,
          favorited,
          header_image_small,
          partner,
          cloudtips_url
        }
      }
    } = this.props
    const width = this.state.windowWidth

    let coverImageUrl = header_image
    if (!header_image) {
      if (header_image_small) coverImageUrl = null
      else coverImageUrl = 'artists-cover'
    }

    return (
      <Layout
        meta={{ title: name, description, image: photo }}
        coverImageUrl={coverImageUrl}
        smallCoverImageUrl={header_image_small}
      >
        <Container>
          <DescriptionSection
            header={name}
            wysiwygDescription={long_description}
            description={description}
            links={links}
            tags={tags}
            className="descriptionSection"
            partner={partner}
            width={width}
          >
            {performances.length > 0 && width > 1000 ? (
              <StarWidgetContainer>
                <StarWidget
                  starsCount={favorited_count}
                  filled={favorited}
                  onPress={() => {
                    this.onStarPress(id, token, favorited, updateArtist, toggleLoginModal)
                  }}
                />
              </StarWidgetContainer>
            ) : undefined }
            {performances.length > 0 && width <= 600 ? (
              <StarWidget
                starsCount={favorited_count}
                filled={favorited}
                className="starWidgetDesc"
                onPress={() => {
                  this.onStarPress(id, token, favorited, updateArtist, toggleLoginModal)
                }}
              />
            ) : undefined }
            <section className="descriptionAside">
              {cloudtips_url && <a className="donationLink widget widget--donation" href={cloudtips_url} target="_blank"><SideWidget
                header={t('artists:donation_title')}
                headerIcon={<svg xmlns="http://www.w3.org/2000/svg" width="35px" height="35px" viewBox="0 0 35 35"><g fill-rule="nonzero" fill="none"><path fill="#FFDE50" d="M35 17.5C35 27.165 27.165 35 17.5 35c-5.095 0-9.681-2.177-12.88-5.652-.84-.912-1.583-1.914-2.216-2.99C.876 23.76 0 20.733 0 17.5 0 7.835 7.835 0 17.5 0c3.233 0 6.26.876 8.859 2.405 1.075.632 2.076 1.376 2.988 2.216C32.822 7.818 35 12.405 35 17.5z"/><path fill="#FFDE50" d="M35 17.5c0 9.447-7.485 17.146-16.849 17.488-9.363-.342-16.848-8.04-16.848-17.488C1.303 8.053 8.788.354 18.15.012 27.515.354 35 8.052 35 17.5z"/><path fill="#FFEA94" d="M29.347 4.621L4.621 29.348c-.84-.912-1.584-1.914-2.217-2.99L26.36 2.406c1.075.632 2.076 1.376 2.988 2.216zm4.446 6.481L11.1 33.794c-1.606-.632-3.097-1.494-4.43-2.546L31.248 6.67c1.052 1.333 1.914 2.824 2.545 4.431z"/><path fill="#FFBD00" d="M31.099 17.5c0 7.51-6.089 13.599-13.599 13.599-2.616 0-5.059-.739-7.132-2.019-.904-.557-1.737-1.218-2.484-1.965-.549-.549-1.052-1.145-1.501-1.781-.619-.877-1.137-1.83-1.536-2.842-.591-1.496-.924-3.123-.944-4.825-.002-.056-.002-.111-.002-.167C3.901 9.99 9.99 3.901 17.5 3.901c.056 0 .112 0 .168.002 1.701.02 3.328.353 4.824.944 1.012.4 1.965.917 2.842 1.536.636.45 1.232.952 1.781 1.501.747.747 1.408 1.58 1.965 2.484 1.28 2.073 2.019 4.516 2.019 7.132z"/><path fill="#FFBD00" d="M27.115 7.884L7.885 27.115c-.55-.549-1.053-1.145-1.502-1.781-.619-.877-1.137-1.83-1.536-2.842-.591-1.496-.924-3.123-.944-4.825-.002-.056-.002-.111-.002-.167C3.901 9.99 9.99 3.901 17.5 3.901c.056 0 .112 0 .168.002 1.701.02 3.328.353 4.824.944 1.012.4 1.965.917 2.842 1.536.636.45 1.232.952 1.781 1.501z"/><path fill="#FFBD00" d="M31.098 17.5c0 7.51-6.088 13.599-13.598 13.599-.258 0-.514-.008-.768-.022 7.153-.398 12.83-6.325 12.83-13.577S23.885 4.32 16.732 3.923c.254-.014.51-.022.768-.022 7.51 0 13.598 6.089 13.598 13.599z"/><path fill="#FFEA94" d="M19.696 20.72c3.476 0 6.304-2.853 6.304-6.36S23.172 8 19.696 8H12.74c-.77 0-1.395.63-1.395 1.408v8.497h-.95c-.771 0-1.396.63-1.396 1.408 0 .777.625 1.407 1.395 1.407h.95v1.619h-.95c-.77 0-1.395.63-1.395 1.408 0 .777.625 1.407 1.395 1.407h.95v1.438c0 .778.625 1.408 1.396 1.408.77 0 1.395-.63 1.395-1.408v-1.438h4.88c.77 0 1.395-.63 1.395-1.407 0-.778-.624-1.408-1.395-1.408h-4.88V20.72h5.56zm-5.56-9.905h5.56c1.937 0 3.514 1.59 3.514 3.545 0 1.955-1.577 3.545-3.514 3.545h-5.56v-7.09z"/></g></svg>}
              >
                {t('artists:donation_text')}
              </SideWidget></a>}
              <SideWidget
                header={t('artists:ARTIST_PROGRAM')}
                className="widget"
                starWidget={
                  performances.length > 0 && width <= 1000 && width > 600 ? (
                      <StarWidget
                        starsCount={favorited_count}
                        filled={favorited}
                        className="starWidgetInSide"
                        onPress={() => {
                          this.onStarPress(id, token, favorited, updateArtist, toggleLoginModal)
                        }}
                      />
                    ) : undefined}
              >
                {performances.length > 0 ? (
                  performances.map(({
                    place, id: perfId, favorited: favoritedPerf, start_datetime, end_datetime
                  }) => {
                    const humanHref = `/place/${place.id}/${place.slug}`
                    if (!place.id) return null
                    return (
                      <LocationDiv key={perfId}>
                        <span className="timeEntry">
                          <button
                            onClick={() => {
                              this.onSmallStarPress(
                                id,
                                perfId,
                                token,
                                favoritedPerf,
                                updatePerformance,
                                updateArtist,
                                toggleLoginModal
                              )
                            }}
                          >
                            <Star className="star" filled={favoritedPerf} />
                          </button>
                          {start_datetime && end_datetime && (
                            <h3 className="timeHeader">
                              <time dateTime={start_datetime}>
                                {normalizeDurationTime(start_datetime, end_datetime)}
                              </time>
                            </h3>
                          )}
                        </span>
                        <Link href={`/place?id=${place.id}`} as={humanHref}>
                          <a className="locationLink" href={humanHref}>
                            <EllipsisText text={place.name} length={66} />
                          </a>
                        </Link>
                      </LocationDiv>
                    )
                  })
                ) : (
                  <div className="scheduleNotReady">{t('common:schedule_is_not_ready')}</div>
                )}
              </SideWidget>
              <section className="embedContentWrapper">
                {vk_playlist_code && <EmbedContent content={vk_playlist_code} withMargin />}
                {youtube_links.map(link => <EmbedContent content={link} key={link} withMargin rounded />)}
              </section>
            </section>
          </DescriptionSection>
          <Footer />
        </Container>
      </Layout>
    )
  }
}

export default withTranslation(['common', 'artists'])(Artists)
